import React, { PropsWithChildren } from 'react';
import { PictureContext, PictureContextProps } from './PictureContext';
import { getImageContextKey } from '@v2/components/imageHandling/helpers';
import { ImageContext } from '@v2/components/imageHandling/types/types';

type PictureProviderProps = PropsWithChildren & Pick<PictureContextProps | 'onImageZoomStart'> & { imageContext: ImageContext };

export const PictureProvider = ({ imageContext, onImageZoomStart, children }: PictureProviderProps) => {
  const imageContextKey = getImageContextKey(imageContext);

  return <PictureContext.Provider value={{ imageContextKey, onImageZoomStart }}>{children}</PictureContext.Provider>;
};
